module.exports = __webpack_public_path__ + "img/tips_weixin_ios.36413820.png";